import data from '../data/mark'
import colors from '../data/colors'

const mark = {
  namespaced: true,
  state: {
    data,
    colors,
    selectedArea: {
      id: 1,
      slug: 'chest',
      name: '胸マーク'
    },
    selectedPart: [
      {
        id: 1,
        slug: 'chest_mark',
        name: 'マーク',
        area_id: 1,
      },
      {
        id: 3,
        slug: 'back_number',
        name: '背番号',
        area_id: 2,
      },
    ],
    selectedElement: [
      {
        id: 1,
        slug: 'both_sides',
        name: '両側',
        area_id: 1,
        part_id: 1,
      },
      {
        id: 3,
        slug: 'japanese',
        name: '日本語',
        area_id: 3,
      },
    ],
    selectedChestItem: {},
    selectedChestItemColor1: null,
    selectedChestItemColor2: null,
    selectedChestItemColor3: null,
    selectedChestNumberItem: {},
    selectedChestNumberItemColor1: null,
    selectedBackItem: {},
    selectedBackItemColor1: null,
    selectedBackItemColor2: null,
    selectedBackNumberItem: {},
    selectedBackNumberItemColor1: null,
    selectedSleeveItem: {},
    selectedSleeveItemColor1: null,
  },
  mutations: {
    // 選択状態の初期化
    clearMark (state) {
      state.selectedArea = {
        id: 1,
        slug: 'chest',
        name: '胸マーク'
      }
      state.selectedPart = [
        {
          id: 1,
          slug: 'chest_mark',
          name: 'マーク',
          area_id: 1,
        },
        {
          id: 3,
          slug: 'back_number',
          name: '背番号',
          area_id: 2,
        },
      ]
      state.selectedElement = [
        {
          id: 1,
          slug: 'both_sides',
          name: '両側',
          area_id: 1,
          part_id: 1,
        },
        {
          id: 3,
          slug: 'japanese',
          name: '日本語',
          area_id: 3,
        },
      ]
      state.selectedChestItem = {}
      state.selectedChestItemColor1 = null
      state.selectedChestItemColor2 = null
      state.selectedChestItemColor3 = null
      state.selectedChestNumberItem = {}
      state.selectedChestNumberItemColor1 = null
      state.selectedBackItem = {}
      state.selectedBackItemColor1 = null
      state.selectedBackItemColor2 = null
      state.selectedBackNumberItem = {}
      state.selectedBackNumberItemColor1 = null
      state.selectedSleeveItem = {}
      state.selectedSleeveItemColor1 = null
    },
    // エリアの選択
    changeArea (state, payload) {
      state.selectedArea = payload
    },
    // パーツの変更
    changePart (state, payload) {
      const addPart = state.selectedPart.concat()
      addPart.unshift(payload);
      state.selectedPart = addPart.filter((item, index, self) => {
        return self.findIndex(i => i.area_id === item.area_id) === index
      })
    },
    // エレメントの変更
    changeElement (state, payload) {
      const addElement = state.selectedElement.concat()
      addElement.unshift(payload);
      state.selectedElement = addElement.filter((item, index, self) => {
        return self.findIndex(i => i.area_id === item.area_id) === index
      })
    },
    // 胸アイテムの選択
    changeChestItem (state, payload) {
      state.selectedChestItem = payload;
    },
    // 胸アイテムの色選択1
    changeChestItemColor1 (state, payload) {
      state.selectedChestItemColor1 = payload;
    },
    // 胸アイテムの色選択2
    changeChestItemColor2 (state, payload) {
      state.selectedChestItemColor2 = payload;
    },
    // 胸アイテムの色選択3
    changeChestItemColor3 (state, payload) {
      state.selectedChestItemColor3 = payload;
    },
    // 胸 - 番号アイテムの選択
    changeChestNumberItem (state, payload) {
      state.selectedChestNumberItem = payload;
    },
    // 胸 - 番号アイテムの色選択1
    changeChestNumberItemColor1 (state, payload) {
      state.selectedChestNumberItemColor1 = payload;
    },
    // 背面 - 背ネームの選択
    changeBackItem (state, payload) {
      // state.selectedBackNumberItem = null;
      state.selectedBackItem = payload;
    },
    // 背面 - 背ネームの色選択1
    changeBackItemColor1 (state, payload) {
      state.selectedBackItemColor1 = payload;
    },
    // 背面 - 背ネームの色選択2
    changeBackItemColor2 (state, payload) {
      state.selectedBackItemColor2 = payload;
    },
    // 背面 - 背番号の選択
    changeBackNumberItem (state, payload) {
      // state.selectedBackItem = null;
      state.selectedBackNumberItem = payload;
    },
    // 背面 - 背番号の色選択1
    changeBackNumberItemColor1 (state, payload) {
      state.selectedBackNumberItemColor1 = payload;
    },
    // 袖アイテムの選択
    changeSleeveItem (state, payload) {
      state.selectedSleeveItem = payload;
    },
    // 袖アイテムの色選択1
    changeSleeveItemColor1 (state, payload) {
      state.selectedSleeveItemColor1 = payload;
    },
  }
}
export default mark